import { setupToolbar } from "./ui/Toolbar";
import { createTranslitEditor, insertText } from "./ui/Quill";
import KeyboardLayout from "./ui/KeyboardLayout";
import { setupTranslitToolbar } from "./ui/TranslitToolbar";
import { setupToggle } from "./ui/Togglable";
import { logEvent } from "./util/Analytics";
import { saveItem } from "./util/LocalStorage";
import { state } from "./SystemState";
import { doOnStateSave } from "./util/StateSave";
const editor = createTranslitEditor(state.contents, state.cursorPosition);
const aboutSection = document.querySelector(".about");
setupToolbar();
setupTranslitToolbar(editor);
setupToggle(aboutSection, "clickableText -small", strings.showAbout, strings.hideAbout, state.aboutHidden, isHidden => {
    saveItem("aboutHidden", isHidden);
    logEvent("about_toggled", { isHidden: isHidden });
});
new KeyboardLayout(state.keyboardHidden, key => insertText(editor, key));
function saveEditorState() {
    const selection = editor.getSelection();
    saveItem("contents", JSON.stringify(editor.getContents()));
    if (selection)
        saveItem("cursorPosition", selection.index);
}
doOnStateSave(saveEditorState);
